import { render } from "./HygieneDashboard.vue?vue&type=template&id=041914d4&scoped=true"
import script from "./HygieneDashboard.vue?vue&type=script&lang=js"
export * from "./HygieneDashboard.vue?vue&type=script&lang=js"

import "./HygieneDashboard.vue?vue&type=style&index=0&id=041914d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041914d4"]])

export default __exports__